import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Sidenav from '../components/sideNav';
import DashboardResume from '../views/dashboard';
import AdminUsers from '../views/users';
import PostSection from '../views/blogs';
import Applications from '../views/applicants';
import Settings from '../views/settings';
import { useSelector } from 'react-redux';

function DashboardAdmin(props) {
  const { className } = props;

  const [state, setState] = React.useState({
    active: false,
    text: '',
    handleMenu: true,
    renderSidenav: true,
    users: [],
    companies: [],
    vacancies: [],
  });

  const match = useRouteMatch();
  const platform = useSelector((state) => state.platform);

  const handleLoader = (action, text) => {
    setState((prev) => ({
      ...prev,

      active: action,
      text: text,
    }));
  };

  // React.useEffect(() => {
  //   window.$crisp = [];
  //   window.CRISP_WEBSITE_ID = '04e5e200-dc66-4f52-b21c-d20935f55213';
  //   (function () {
  //     const d = document;
  //     const s = d.createElement('script');
  //     s.src = 'https://client.crisp.chat/l.js';
  //     s.async = 1;
  //     d.getElementsByTagName('head')[0].appendChild(s);
  //   })();
  // }, []);

  return (
    <section className={className}>
      <Grid container>
        <Grid item lg={1}>
          <Sidenav
            show={state.handleMenu}
            {...props}
            companies={state.companies}
            users={state.users}
            vacancies={state.vacancies}
            adminColor={platform?.adminColor}
          />
        </Grid>
        <Grid item lg={11}>
          <div className="main menu-show">
            <Switch>
              <Route exact path={`${match.url}/platform`} component={Settings} />

              <Route exact path={`${match.url}/dashboard`} component={DashboardResume} />

              <Route exact path={`${match.url}/adminusers`} component={AdminUsers} />

              <Route exact path={`${match.url}/blog`} component={PostSection} />

              <Route exact path={`${match.url}/applications`} component={Applications} />
            </Switch>
            <p
              style={{
                fontFamily: 'Sofia Pro, sans-serif',
                fontSize: '16px',
                fontWeight: '500',
                lineHeight: '32px',
                letterSpacing: '0px',
                color: '#AEAEC1',
                padding: '0px 0px 32px 55px',
              }}>
              Copyright LaPieza.io 2020
            </p>
          </div>
        </Grid>
      </Grid>
    </section>
  );
}

export default styled(DashboardAdmin)`
  padding: 0;
  height: 100vh;
  .main {
    background-color: #f5f5f5;
    top: 0px;
    margin-top: 0px;
    max-width: 100% !important;
  }
  .menu-show {
    transition: 0.5s;
  }
  .copyright {
    font-family: 'Cooper Md BT', sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0px;
    color: #aeaec1;
    padding: 0px 0px 32px 55px;
  }
`;
